export const MAINTENANCE_PATH = "/maintenance";

export function isTruthyEnv(value: string | undefined): boolean {
  return (
    value
      ?.trim()
      .replace(/^["']|["']$/g, "")
      .toLowerCase() === "true"
  );
}

export function getMaintenanceMode(): boolean {
  return (
    isTruthyEnv(process.env.MAINTENANCE_MODE) ||
    isTruthyEnv(process.env.NEXT_PUBLIC_MAINTENANCE_MODE)
  );
}
